import React from 'react';

/** Mesma aparência do StyledInput para os `<textarea>` soltos das anamneses. */
export const CLASSE_TEXTAREA =
  'w-full px-4 py-3.5 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 border border-nude-200 dark:border-gray-600 rounded-input shadow-soft transition-colors duration-200 ease-soft placeholder:text-nude-300 dark:placeholder:text-gray-500 hover:border-blush-200 focus:outline-none focus:border-blush-400 focus:ring-2 focus:ring-blush-100 resize-none';

interface StyledInputProps {
  label?: string;
  name: string;
  type?: string;
  /** Opcional para funcionar tanto controlado quanto com o register do RHF. */
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  placeholder?: string;
  /** Teclado numérico no celular sem virar `type="number"` (que aceita e/+/-). */
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>['inputMode'];
  error?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
}

const StyledInput = React.forwardRef<HTMLInputElement, StyledInputProps>(function StyledInput(
  {
    label,
    name,
    type = 'text',
    value,
    onChange,
    onBlur,
    onKeyDown,
    placeholder = '',
    inputMode,
    error = '',
    disabled = false,
    icon,
    rightIcon,
    className = '',
  },
  ref
) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="text-xs font-medium text-nude-700 dark:text-gray-400 tracking-wide uppercase"
        >
          {label}
        </label>
      )}

      <div className="relative">
        {icon && (
          <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-nude-400 w-4 h-4">
            {icon}
          </span>
        )}

        <input
          ref={ref}
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          inputMode={inputMode}
          disabled={disabled}
          aria-invalid={!!error}
          className={`
            w-full
            px-4 py-3.5
            ${icon ? 'pl-11' : ''}
            ${rightIcon ? 'pr-11' : ''}
            text-sm text-gray-700 dark:text-gray-200
            bg-white dark:bg-gray-700
            border border-nude-200 dark:border-gray-600
            rounded-input
            shadow-soft
            transition-colors duration-200 ease-soft
            placeholder:text-nude-300 dark:placeholder:text-gray-500
            hover:border-blush-200
            focus:outline-none focus:border-blush-400 focus:ring-2 focus:ring-blush-100
            disabled:bg-nude-50 dark:disabled:bg-gray-800 disabled:text-nude-400 dark:disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-300 focus:border-red-400 focus:ring-red-100' : ''}
          `}
        />

        {rightIcon && (
          <span className="absolute right-3.5 top-1/2 -translate-y-1/2 text-nude-400">
            {rightIcon}
          </span>
        )}
      </div>

      {error && (
        <p className="text-xs text-red-500 mt-0.5 pl-1">{error}</p>
      )}
    </div>
  );
});

export default StyledInput;
